import { useSnackbar } from 'notistack';
import React from 'react';

import { useAccount, useMsal } from "@azure/msal-react";

export const ApiDomains = {
    GiustiziaMap: window._env_.GM_API_URL,
    //GiustiziaMap: "https://localhost:5044/api",
}

export const HttpMethods = {

    GET: 'GET',
    POST: 'POST',
    DELETE: 'DELETE',
    PUT: 'PUT',
}

const compileRoute = (route, params) => {
    if (params) {
        const paramsPropNames = Object.getOwnPropertyNames(params);
        if (paramsPropNames && paramsPropNames.length > 0) {
            route = `${route}?`
            paramsPropNames
                .filter(paramPropName => params[paramPropName] !== null && params[paramPropName] !== undefined)
                .forEach(paramPropName => {
                    const routeParamPropName = `{${paramPropName}}`;
                    const startIndexOfParamPropName = route.toLowerCase().indexOf(routeParamPropName.toLocaleLowerCase());
                    if (startIndexOfParamPropName === -1)
                        route = `${route}${paramPropName}=${params[paramPropName]}&`;
                    else
                        route = `${route.substr(0, startIndexOfParamPropName)}${params[paramPropName]}${route.substr(startIndexOfParamPropName + routeParamPropName.length, route.length)}`;
                });
            route = route.substr(0, route.length - 1);
        }
    }
    return route;
}

export const ApiRoutes = {
    Competenza: {
        GetCompetenza: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Competenze/{competenzaId}`, params),
        GetCompetenze: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Competenze`, params),
        AddCompetenza: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Competenze`, params),
        UpdateCompetenza: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Competenze/{competenzaId}`, params),
        DeleteCompetenza: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Competenze/{competenzaId}`, params),
        AssignCompetenze: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Competenze/{competenzaId}/Uffici/{ufficioId}/assegna`, params),
    },
    Comune: {
        GetComuni: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni`, params),
        GetUffici: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Uffici`, params),
        GetUfficiXML: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Uffici/XML`, params),
        GetAltriUffici: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/AltriUffici`, params),
        GetAltriUfficiXML: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/AltriUffici/XML`, params),
        GetStorici: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze/{competenzaId}/storici`, params),
        GetStorico: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Comuni/{comuneId}/Competenze/{competenzaId}/storici/{storicoId}`, params),
    },
    Provincia: {
        GetProvince: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Province`, params),
    },
    Regione: {
        GetRegioni: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Regioni`, params),
    },
    TipoUfficio: {
        GetTipiUffici: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/TipiUffici`, params),
    },
    Ufficio: {
        GetUfficiTipoUfficioXML: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/TipoUfficio/XML`, params),
        GetUfficiTipoUfficio: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/TipoUfficio`, params),
        GetUfficoLiberaXML: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/Libera/XML`, params),
        GetUfficiLibera: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/Libera`, params),
        GetUfficiDistrettoXML: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/Distrettuale/XML`, params),
        GetUfficiDistretto: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/Distrettuale`, params),
        GetUfficiTerritorioXML: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/Territorio/XML`, params),
        GetUfficiTerritorio: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/Territorio`, params),
        GetUffici: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici`, params),
        GetUfficiXML: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/XML`, params),
        GetDistretti: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/Distretti`, params),
        GetCircondari: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/Circondari`, params),
        GetComuni: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Uffici/{ufficioId}/Comuni`, params),
    },
    Impostazione: {
        GetImpostazioni: (params) => compileRoute(`${ApiDomains.GiustiziaMap}/Impostazioni`),
    }
}

export const FetchContext = React.createContext(null);

const { Provider } = FetchContext;
export const FetchProvider = ({ ...props }) => {

    const { accounts } = useMsal();
    const account = useAccount(accounts[0] || {});

    const { enqueueSnackbar } = useSnackbar();

    const snackOptions = { variant: "error", autoHideDuration: 5000 };

    const createError = (code, message) => {
        const error = new Error(message);
        error.code = code;
        return error;
    }

    // source: https://dev.to/ycmjason/javascript-fetch-retry-upon-failure-3p6g
    const fetchRetry = (retries, api, cfg) => {
        return fetch(api, cfg).catch(function (error) {
            if (retries === 1) throw error;
            return fetchRetry(api, cfg, retries - 1);
        });
    }

    const fetchOk = (api, cfg, noHeader = false) => {

        const headers = {};
        if (cfg.body && (typeof cfg.body === "string" || cfg.body instanceof String)) {
            headers["Content-Type"] = "application/json"
        }

        if (cfg.headers) {
            for (var pair of Object.entries(cfg.headers)) {
                headers[pair[0]] = pair[1];
            }
        }

        cfg = {
            ...cfg,
            cache: 'no-cache',
            headers: noHeader ? new Headers() : new Headers({
                ...headers,
                "Cache-Control": "no-cache",
                "Pragma": "no-cache",
                "Expires": "0",
                "XLanguage": cfg.cultureName || "default"
            })
        };

        return fetch(api, cfg)
            .then(r => {
                if (r.ok) {
                    return r;
                } else {
                    switch (r.status) {
                        // Bad Request
                        case 400:
                            return r.json()
                                .then(data => {
                                    if (data.errors) {
                                        const errorKeys = Object.keys(data.errors);
                                        if (cfg.collectErrorDetails) {
                                            const error = new Error("Invalid data supplied");
                                            error.details = errorKeys.map(x => ({ errorId: x, message: data.errors[x][0] }));
                                            error.code = r.status;
                                            return Promise.reject(error);
                                        } else {
                                            errorKeys.forEach(errorKey => {
                                                const error = data.errors[errorKey][0];
                                                enqueueSnackbar(error, snackOptions);
                                            });
                                        }
                                    }
                                    return Promise.reject(createError(r.status, "Invalid data supplied"));
                                });
                        // Unauthorized
                        case 401:
                            return Promise.reject(createError(r.status, "User is not authorized"));
                        // Forbidden
                        case 403:
                            return Promise.reject(createError(r.status, "User is not allowed"));
                        // Not Found
                        case 404:
                            return Promise.reject(createError(r.status, "Resource not found"));
                        // Server Error
                        case 500:
                            return r.json()
                                .then(data => {
                                    let message = null;
                                    if (data.message) message = data.message;
                                    else message = "Si è verificato un errore interno";
                                    return Promise.reject(createError(r.status, message));
                                });
                        // Not handled
                        default:
                            return Promise.reject(createError(r.status, "Qualcosa è andato storto"));
                    }
                }
            })
            .catch(error => {
                enqueueSnackbar(error.message, snackOptions);
                return Promise.reject(error);
            });
    }

    const fetchAuthorized = (api, cfg) => {
        const accessToken = account.idTokenClaims.IdpAccessToken;
        return fetchOk(api, {
            ...cfg,
            headers: new Headers({
                "Authorization": `Bearer ${accessToken}`
            })
        })
    }

    return (
        <Provider value={{
            fetchRetry,
            fetchOk,
            fetchAuthorized
        }}>
            {props.children}
        </Provider>
    );
}